import OptimizationStore from "../../../../optimization/store/OptimizationStore";
import * as keys from "./keys";
import ProductConstants from 'constants/ProductConstants';

class Utils {
  generatePPTList(planOption, policyTerm) {
    let pptList = [];
    if (Number(planOption) === 1 && Number(policyTerm) === 15) {
      pptList.push({ label: "8", id: 8 });
    } else if (Number(planOption) === 2 && Number(policyTerm) === 15) {
      pptList.push({ label: "5", id: 5 }, { label: "8", id: 8 });
    } else if (Number(planOption) === 1 && Number(policyTerm) != 15) {
      pptList.push(
        { label: "8", id: 8 },
        { label: "10", id: 10 },
        { label: "12", id: 12 }
      );
    } else if (Number(planOption) === 2 && Number(policyTerm) != 15) {
      pptList.push(
        { label: "5", id: 5 },
        { label: "8", id: 8 },
        { label: "10", id: 10 },
        { label: "12", id: 12 }
      );
    }

    return pptList;
  }

  // handled ASB 1
  handleAsbCondition(formRef, asb1Value) {
    if (Number(asb1Value) === 6) {
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-2",true,88);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",true,166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(1st-opt-in)",false);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(1st-opt-in)",false);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-2",false,88);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",true,166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  setHideAndResetValue(formRef, key, value, noOptParamValue) {
    formRef.$(key).set("extra", { ...formRef.$(key).extra, hide: value });
    if (noOptParamValue) {
      formRef.$(key).set("value", { label: "No", id: noOptParamValue });
    } else {
      formRef.$(key).set("value", "");
    }
  }

  // handled ASB start year 1
  fetchASBstartPolicyOne(planOption, pt, ppt, preDefinedOptList) {
    let startYearList = [];
    // let value = Number(pt) === 40 ? Number(pt) - 1 : Number(pt);
    let value = Number(pt) - 1 ;
    let startPoint = 1;
    if (Number(planOption) === 2) startPoint = Number(Number(ppt) + 2);
    for (let i = startPoint; i <= value; i++) {
      let optData = preDefinedOptList.find((item)=> item.label === i)
      startYearList.push(optData);
    }
    return startYearList;
  }

  handleASBstartPolicyOneConditions(formRef, productName) {
    if (formRef.$("accrual-of-survival-benefits").value.id == 5) {
      let asbStartYearOneList = this.fetchASBstartPolicyOne(
        formRef.$("plan-option").value.id,
        formRef.$("policy-term").value.id,
        formRef.$("premium-paying-term").value.id,
        formRef.$("asb-start-policy-year-(1st-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-start-policy-year-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-policy-year-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
      });

      let selectedAsbStartYearOne = asbStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-policy-year-(1st-opt-in)").value.id
      );
      if(productName === ProductConstants.BHARAT_SAVINGS_STAR_LUMPSUM || 
        productName === ProductConstants.POS_BHARAT_SAVINGS_STAR_LUMPSUM) {
           if(Number(formRef.$("plan-option").value.id) === 2) {
            let selectedAsbStartYearOne = asbStartYearOneList.some(
              (item) =>
                Number(item.label) === Number(formRef.$("premium-paying-term").value.label)
            );
            if(selectedAsbStartYearOne) {
              formRef .$("asb-start-policy-year-(1st-opt-in)").set("value", asbStartYearOneList.find(
                (item) =>
                  Number(item.label) === Number(formRef.$("premium-paying-term").value.label)
              ));
            } else {
            formRef .$("asb-start-policy-year-(1st-opt-in)").set("value", asbStartYearOneList[0]);
            }

           } else {
            formRef .$("asb-start-policy-year-(1st-opt-in)").set("value", asbStartYearOneList[0]);
           }
        } else {
          formRef
            .$("asb-start-policy-year-(1st-opt-in)")
            .set("value", asbStartYearOneList[0]);
        }
      // if (!selectedAsbStartYearOne) {
      // }

      let asbEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-policy-year-(1st-opt-in)").value.id,
        asbStartYearOneList,
        formRef.$("asb-end-policy-year-(1st-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-policy-year-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-policy-year-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
      });

      let selectedAsbEndYearOne = asbEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-policy-year-(1st-opt-in)").value.id
      );
      // if (!selectedAsbEndYearOne) {
        formRef
          .$("asb-end-policy-year-(1st-opt-in)")
          .set("value", asbEndYearOneList[asbEndYearOneList.length - 1]);
      // }
    }
  }

  handleASBFirstStartEndCondition(formRef, asbValue) {
    if (Number(asbValue) === 6) {
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-2",true,88);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",true,166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-2",false,88);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",true,166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  // handled ASB end year 1
  fetchASBendPolicyOne(startYear1, asbStartYearOneList, preDefinedOptList) {
    let endYearList = [];
    asbStartYearOneList.forEach((item) => {
      if (item.id >= startYear1) {
        let optData = preDefinedOptList.find((opt)=> opt.label === item.label)
        endYearList.push(optData);
      } 
    });
    return endYearList;
  }

  // handled ASB 2nd year condition
  handleAsbTwoCondition(formRef, asb2Value) {
    if (Number(asb2Value) === 88) {
      this.setHideAndResetValue(formRef, "asb-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef, "asb-end-policy-year-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",true, 166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(2nd-opt-in)",false);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(2nd-opt-in)",false);
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",false, 166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  // Handled ASB 2 Start Year 
  handleASBTwoStartEndCondition(formRef, asbValue) {
    if (Number(asbValue) === 88) {
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",true,166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"accrual-of-survival-benefits-year-3",false,166);
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
    }
  }

  handleASBTwostartPolicyOneConditions(formRef) {
    if (formRef.$("accrual-of-survival-benefits-year-2").value.id == 87) {
      let asbTwoStartYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-end-policy-year-(1st-opt-in)").value.id + 2,
        formRef.$("asb-end-policy-year-(1st-opt-in)").extra.optionList,
        formRef.$("asb-start-policy-year-(2nd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-start-policy-year-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-start-policy-year-(2nd-opt-in)").extra,
        optionList: asbTwoStartYearOneList,
      });

      let selectedAsbTwoStartYearOne = asbTwoStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-policy-year-(2nd-opt-in)").value.id
      );
      if (!selectedAsbTwoStartYearOne) {
        formRef
          .$("asb-start-policy-year-(2nd-opt-in)")
          .set("value", asbTwoStartYearOneList[asbTwoStartYearOneList.length - 1]);
      }

      let asbTwoEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-policy-year-(2nd-opt-in)").value.id,
        asbTwoStartYearOneList,
        formRef.$("asb-end-policy-year-(2nd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-policy-year-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-end-policy-year-(2nd-opt-in)").extra,
        optionList: asbTwoEndYearOneList,
      });

      let selectedAsbTwoEndYearOne = asbTwoEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-policy-year-(2nd-opt-in)").value.id
      );
      if (!selectedAsbTwoEndYearOne) {
        formRef
          .$("asb-end-policy-year-(2nd-opt-in)")
          .set("value", asbTwoEndYearOneList[asbTwoEndYearOneList.length - 1]);
      }
    }
  }

  // handled ASB 3rd year condition
  handleAsbThreeCondition(formRef, asb3Value) {
    if (Number(asb3Value) === 166) {
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"asb-start-policy-year-(3rd-opt-in)",false);
      this.setHideAndResetValue(formRef,"asb-end-policy-year-(3rd-opt-in)",false);
      this.setHideAndResetValue(formRef,"preponement-of-future-income",false,240);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  // Handled ASB 3 Start Year 
  handleASBThreestartPolicyOneConditions(formRef) {
    if (formRef.$("accrual-of-survival-benefits-year-3").value.id == 165) {
      let asbThreeStartYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-end-policy-year-(2nd-opt-in)").value.id + 2,
        formRef.$("asb-end-policy-year-(2nd-opt-in)").extra.optionList,
        formRef.$("asb-start-policy-year-(3rd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-start-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-policy-year-(3rd-opt-in)").extra,
        optionList: asbThreeStartYearOneList,
      });

      let selectedAsbThreeStartYearOne = asbThreeStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-policy-year-(3rd-opt-in)").value.id
      );
      if (!selectedAsbThreeStartYearOne) {
        formRef
          .$("asb-start-policy-year-(3rd-opt-in)")
          .set("value", asbThreeStartYearOneList[asbThreeStartYearOneList.length - 1]);
      }

      let asbThreeEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-policy-year-(3rd-opt-in)").value.id,
        asbThreeStartYearOneList,
        formRef.$("asb-end-policy-year-(3rd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-end-policy-year-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
      });

      let selectedAsbThreeEndYearOne = asbThreeEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-policy-year-(3rd-opt-in)").value.id
      );
      if (!selectedAsbThreeEndYearOne) {
        formRef
          .$("asb-end-policy-year-(3rd-opt-in)")
          .set("value", asbThreeEndYearOneList[asbThreeEndYearOneList.length - 1]);
      }
    }
  }

  // handled Preponement 1
  handlePreponementOneCondition(formRef, preponementValue) {
    if (Number(preponementValue) === 240) {
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(1st-opt-in)",false);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(1st-opt-in)",false);
      this.setHideAndResetValue(formRef,"preponement-year-2",false,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  // handled Preponement start year 1
  fetchPreponementStartYearOne(startYear, endYear, planOption, preDefinedOptList, year, formRef) {
    let startYearList = []
    let startPoint = Number(planOption) === 1 ? Number(startYear) + 1 : Number(startYear) + 2
    if(Number(planOption) === 2 && year !== 'first') {
      startPoint = Number(startYear) + 1
    } 
    for (let i = startPoint; i <= Number(endYear); i++) {
      let optData = preDefinedOptList.find((item)=> item.label === i)
      startYearList.push(optData);
    }

    let selectedYearList = []
    if(formRef.$('asb-start-policy-year-(1st-opt-in)').value)
      selectedYearList.push(formRef.$('asb-start-policy-year-(1st-opt-in)').value)
    
    if(formRef.$('asb-end-policy-year-(1st-opt-in)').value)
      selectedYearList.push(formRef.$('asb-end-policy-year-(1st-opt-in)').value)
    
    if(formRef.$('asb-start-policy-year-(2nd-opt-in)').value)
      selectedYearList.push(formRef.$('asb-start-policy-year-(2nd-opt-in)').value)

    if(formRef.$('asb-end-policy-year-(2nd-opt-in)').value)
      selectedYearList.push(formRef.$('asb-end-policy-year-(2nd-opt-in)').value)
    
    if(formRef.$('asb-start-policy-year-(3rd-opt-in)').value)
      selectedYearList.push(formRef.$('asb-start-policy-year-(3rd-opt-in)').value)

    if(formRef.$('asb-end-policy-year-(3rd-opt-in)').value)
      selectedYearList.push(formRef.$('asb-end-policy-year-(3rd-opt-in)').value)

    if(year === 'second') {
      if(formRef.$('pfi-start-policy-year-(1st-opt-in)').value)
        selectedYearList.push(formRef.$('pfi-start-policy-year-(1st-opt-in)').value)
  
      if(formRef.$('pfi-end-policy-year-(1st-opt-in)').value)
        selectedYearList.push(formRef.$('pfi-end-policy-year-(1st-opt-in)').value)
    }

    if(year === 'third') {
      if(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value)
        selectedYearList.push(formRef.$('pfi-start-policy-year-(2nd-opt-in)').value)
      
      if(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value)
        selectedYearList.push(formRef.$('pfi-end-policy-year-(2nd-opt-in)').value)
    }
    let maxSelectedYear = selectedYearList.filter((item)=> item !== 'value')
    maxSelectedYear =  Math.max(...maxSelectedYear.map(item => Number(item.label)))
    let preponementList =  startYearList.filter(obj => Number(obj.label) > maxSelectedYear)
    return preponementList
  }

  handlePreponementStartYearOneConditions(formRef) {             
    if (formRef.$("preponement-of-future-income").value.id == 239) {
      let startYearOneList = this.fetchPreponementStartYearOne(
        formRef.$('premium-paying-term').value.id, 
        formRef.$('policy-term').value.id, 
        formRef.$("plan-option").value.id, 
        formRef.$("pfi-start-policy-year-(1st-opt-in)").extra.preDefinedOptList,
        'first',
        formRef
        )

        formRef.$("pfi-start-policy-year-(1st-opt-in)").set("extra", {
          ...formRef.$("pfi-start-policy-year-(1st-opt-in)").extra,
          optionList: startYearOneList,
      });

      let selectedStartYearOne = startYearOneList.some(
        (item) =>
          item.id === formRef.$("pfi-start-policy-year-(1st-opt-in)").value.id
      );
      if (!selectedStartYearOne) {
        formRef
          .$("pfi-start-policy-year-(1st-opt-in)")
          .set("value", startYearOneList[0]);
      }

      let endYearOneList = this.fetchPreponementEndYearList(
        formRef.$("pfi-start-policy-year-(1st-opt-in)").value.label, 
        formRef.$("policy-term").value.id,
        formRef.$("pfi-end-policy-year-(1st-opt-in)").extra.preDefinedOptList
      );

      formRef.$("pfi-end-policy-year-(1st-opt-in)").set("extra", {
        ...formRef.$("pfi-end-policy-year-(1st-opt-in)").extra,
        optionList: endYearOneList,
      });

      let selectedEndYearOne = endYearOneList.some(
        (item) =>
          item.id === formRef.$("pfi-end-policy-year-(1st-opt-in)").value.id
      );
      if (!selectedEndYearOne) {
        let optData = endYearOneList.find((item)=> item.label === formRef.$("pfi-start-policy-year-(1st-opt-in)").value.label)
        formRef
          .$("pfi-end-policy-year-(1st-opt-in)")
          .set("value", optData);
      }
    }
  }

  handlePreponementFirstStartEndCondition(formRef, preponementValue) {
    if (Number(preponementValue) === 240) {
      this.setHideAndResetValue(formRef,"preponement-year-2",true,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"preponement-year-2",false,310);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  // Preponement end year 1
  fetchPreponementEndYearList(startYear, pt, preDefinedOptList) {
    let list = []
    let endYear = Number(startYear + 1) > Number(pt) ? Number(pt) : Number(startYear + 1) 
    for (let i = Number(startYear); i <= endYear; i++) {
      let optData = preDefinedOptList.find((item)=> item.label === i)
      list.push(optData);
    }
    return list
  }

  // handled preponement 2nd year condition
  handlePreponementTwoCondition(formRef, preponementEndYearOne) {
    if (Number(preponementEndYearOne) === 310) {
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",true);
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(2nd-opt-in)",false);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(2nd-opt-in)",false);
      this.setHideAndResetValue(formRef,"preponement-year-3",false,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  // Handled Preponement 2 Start Year 
  handlePreponementTwostartPolicyOneConditions(formRef) {
    if (formRef.$("preponement-year-2").value.id == 309) {
      let preponementTwoStartYearOneList = this.fetchPreponementStartYearOne(
        formRef.$("pfi-end-policy-year-(1st-opt-in)").value.label,
        formRef.$('policy-term').value.id,
        formRef.$("plan-option").value.id,
        formRef.$("pfi-start-policy-year-(2nd-opt-in)").extra.preDefinedOptList,
        'second',
        formRef
      );
      formRef.$("pfi-start-policy-year-(2nd-opt-in)").set("extra", {
        ...formRef.$("pfi-start-policy-year-(2nd-opt-in)").extra,
        optionList: preponementTwoStartYearOneList,
      });

      let selectedTwoStartYearOne = preponementTwoStartYearOneList.some(
        (item) =>
          item.id === formRef.$("pfi-start-policy-year-(2nd-opt-in)").value.id
      );
      if (!selectedTwoStartYearOne) {
        formRef
          .$("pfi-start-policy-year-(2nd-opt-in)")
          .set("value", preponementTwoStartYearOneList[0]);
      }

      let preponementTwoEndYearOneList = this.fetchPreponementEndYearList(
        formRef.$("pfi-start-policy-year-(2nd-opt-in)").value.label,
        formRef.$("policy-term").value.id,
        formRef.$("pfi-end-policy-year-(2nd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("pfi-end-policy-year-(2nd-opt-in)").set("extra", {
        ...formRef.$("pfi-end-policy-year-(2nd-opt-in)").extra,
        optionList: preponementTwoEndYearOneList,
      });

      let selectedTwoEndYearOne = preponementTwoEndYearOneList.some(
        (item) =>
          item.id === formRef.$("pfi-end-policy-year-(2nd-opt-in)").value.id
      );
      if (!selectedTwoEndYearOne) {
        formRef
          .$("pfi-end-policy-year-(2nd-opt-in)")
          .set("value", preponementTwoEndYearOneList[0]);
      }
    }
  }

  handlePreponementTwoStartEndCondition(formRef, preponementEndYearOne) {
    if (Number(preponementEndYearOne) === 310) {
      this.setHideAndResetValue(formRef,"preponement-year-3",true,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"preponement-year-3",false,376);
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    }
  }

  // handled preponement 3rd year condition
  handlePreponementThreeCondition(formRef, preponementEndYearThree) {
    if (Number(preponementEndYearThree) === 376) {
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",true);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",true);
    } else {
      this.setHideAndResetValue(formRef,"pfi-start-policy-year-(3rd-opt-in)",false);
      this.setHideAndResetValue(formRef,"pfi-end-policy-year-(3rd-opt-in)",false);
    }
  }
  
  // Handled Preponement 3 Start Year 
  handlePreponementThreestartPolicyOneConditions(formRef) {
    if (formRef.$("preponement-year-3").value.id == 375) {
      let preponementThreeStartYearOneList = this.fetchPreponementStartYearOne(
        formRef.$("pfi-end-policy-year-(2nd-opt-in)").value.label,
        formRef.$('policy-term').value.id,
        formRef.$("plan-option").value.id,
        formRef.$("pfi-start-policy-year-(3rd-opt-in)").extra.preDefinedOptList,
        'third',
        formRef
      );
      formRef.$("pfi-start-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("pfi-start-policy-year-(3rd-opt-in)").extra,
        optionList: preponementThreeStartYearOneList,
      });

      let selectedThreeStartYearOne = preponementThreeStartYearOneList.some(
        (item) =>
          item.id === formRef.$("pfi-start-policy-year-(3rd-opt-in)").value.id
      );
      if (!selectedThreeStartYearOne) {
        formRef
          .$("pfi-start-policy-year-(3rd-opt-in)")
          .set("value", preponementThreeStartYearOneList[0]);
      }

      let preponementThreeEndYearOneList = this.fetchPreponementEndYearList(
        formRef.$("pfi-start-policy-year-(3rd-opt-in)").value.label,
        formRef.$("policy-term").value.id,
        formRef.$("pfi-end-policy-year-(3rd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("pfi-end-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("pfi-end-policy-year-(3rd-opt-in)").extra,
        optionList: preponementThreeEndYearOneList,
      });

      let selectedThreeEndYearOne = preponementThreeEndYearOneList.some(
        (item) =>
          item.id === formRef.$("pfi-end-policy-year-(3rd-opt-in)").value.id
      );
      if (!selectedThreeEndYearOne) {
        formRef
          .$("pfi-end-policy-year-(3rd-opt-in)")
          .set("value", preponementThreeEndYearOneList[0]);
      }
    }
  }

  getTotalPrice = (biResponse) => {
    try {
      return Number(biResponse?.INST_DISP);
    } catch (e) {
      return 0;
    }
  };


  getAdbList = () => {
    let list = [];
    for (let index = 0; index <= 100; index = index + 5) {
      if (index != 100) {
        list.push({
          id: index == 0 ? 1 : index,
          label: (index == 0 ? 1 : index) + " L",
        });
      } else {
        list.push({
          id: index,
          label: 1 + " Cr.",
        });
      }
    }
    return list;
  };

  getAtpdList = () => {
    return this.benefitAmountList(100000, 1000000);
  };

  getCriticalIllnessList = () => {
    return this.benefitAmountList(100000, 500000);
  };

  benefitAmountList = (min, max) => {
    let values = [];
  
    max = Math.round(max / 100000);
    for (let i = 1; i <= max; i++) {
      values.push({ id: i, label: i + " L" });
    }
    return values;
  };

  updateBi = (key, value, package_id, formRef, productData, updateBiRequest) => {
    
    let biData = OptimizationStore.fetchBiRequestForCompareProduct(
      package_id,
      productData?.data?.family_product_id
    );
    let biRequest = biData.data.bi_request;
    switch (key) {
      case keys.PR_PT:
        biRequest[keys.PR_PT] = value.PR_PT;
        biRequest[keys.PR_PPT] = value.PR_PPT;
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.ASB_STARTPOLICYYEAR_1;
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.ASB_ENDPOLICYYEAR_1;
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.PFI_STARTPOLICYYEAR_1;
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.PFI_ENDPOLICYYEAR_1
        break;

      case keys.PR_PPT:
        biRequest[keys.PR_PPT] = value.PR_PPT
        biRequest[keys.PR_SAMF] = value.PR_SAMF
        biRequest[keys.PREMIUMBREAKBENEFIT] = value.PREMIUMBREAKBENEFIT;
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.PFI_STARTPOLICYYEAR_1;
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.PFI_ENDPOLICYYEAR_1
        break;

      case keys.INOUT_MODE:
        biRequest[keys.INOUT_MODE] = value;
        break;

      case keys.INCOMEBENEFITPAYOUTFREQUENCY:
        biRequest[keys.INCOMEBENEFITPAYOUTFREQUENCY] = value;
        break;

      case keys.PLANOPTION:
        biRequest[keys.PLANOPTION] = value.PLANOPTION;
        biRequest[keys.PR_PPT] = value.PR_PPT;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_1] = 6;
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = "";
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = "";
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = 88;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = "";
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = "";
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = 166;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = "";
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = "";
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = 240
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = ""
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = ""
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = 310
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = ""
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = ""
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = 376
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = ""
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = "";
        break;

      case keys.PREMIUMBREAKBENEFIT:
        biRequest[keys.PREMIUMBREAKBENEFIT] = value.PREMIUMBREAKBENEFIT
        biRequest[keys.PR_PPT] = value.PR_PPT;
        break;

      case keys.ACCRUALOFSURVIVALBENEFIT_1:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_1] = value.asb1;
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStartYear1;
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEndYear1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_1:
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStart1
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ASB_ENDPOLICYYEAR_1:
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ACCRUALOFSURVIVALBENEFIT_2:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_2:
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ASB_ENDPOLICYYEAR_2:
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ACCRUALOFSURVIVALBENEFIT_3:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_3:
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.ASB_ENDPOLICYYEAR_3:
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PREPONEMENTOFFUTUREINCOME_1:
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_1] = value.preponement1
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStartYear1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEndYear1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PFI_STARTPOLICYYEAR_1:
        biRequest[keys.PFI_STARTPOLICYYEAR_1] = value.preponementStart1
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEnd1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PFI_ENDPOLICYYEAR_1:
        biRequest[keys.PFI_ENDPOLICYYEAR_1] = value.preponementEnd1
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PREPONEMENTOFFUTUREINCOME_2:
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_2] = value.preponement2
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStartYear2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEndYear2
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PFI_STARTPOLICYYEAR_2:
        biRequest[keys.PFI_STARTPOLICYYEAR_2] = value.preponementStart2
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEnd2;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PFI_ENDPOLICYYEAR_2:
        biRequest[keys.PFI_ENDPOLICYYEAR_2] = value.preponementEnd2;
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PREPONEMENTOFFUTUREINCOME_3:
        biRequest[keys.PREPONEMENTOFFUTUREINCOME_3] = value.preponement3
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStartYear3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEndYear3;
        break;

      case keys.PFI_STARTPOLICYYEAR_3:
        biRequest[keys.PFI_STARTPOLICYYEAR_3] = value.preponementStart3
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value.preponementEnd3;
        break;

      case keys.PFI_ENDPOLICYYEAR_3:
        biRequest[keys.PFI_ENDPOLICYYEAR_3] = value;
        break;

      case keys.AUTORENEWALBOOSTER:
        biRequest[keys.AUTORENEWALBOOSTER] = value;
        break;

      case keys.PR_SAMF:
        biRequest[keys.PR_SAMF] = value
        break;
      
      case keys.WOP_RIDER:
        biRequest[keys.WOP_RIDER] = value;
        break;

      case keys.ADB_RIDER:
        if (value) {
          biRequest[keys.ADB_RIDER] = value;
        } else {
          biRequest[keys.ADB_RIDER] = "";
        }
        break;

      case keys.ATPD_RIDER:
        if (value) {
          biRequest[keys.ATPD_RIDER] = value;
        } else {
          biRequest[keys.ATPD_RIDER] = "";
        }
        break;

      case keys.Critical_ILLNESS_RIDER:
        if (value) {
          biRequest[keys.Critical_ILLNESS_RIDER] = value;
        } else {
          biRequest[keys.Critical_ILLNESS_RIDER] = "";
        }
        break;

      case keys.PWB_RIDER:
        if (value) {
          biRequest[keys.PWB_RIDER] = "1";
          biRequest.PWB = "" + value;
        } else {
          biRequest[keys.PWB_RIDER] = "";
        }
        break;
    }
    OptimizationStore.updateBiRequestForComapareProduct(
      package_id,
      biRequest,
      productData.data.family_product_id,
      key,
      value,
      updateBiRequest
    );
  };

  newPolicyTimeLineData(element, productName) {
    const { ANN_PREM_YEARLY, DB_G, AUTO_RENEW_BOOSTER, IB_PAY_WO_AP, LA, MB_G } = element;
  
       let data = {
          youPay: Math.round(ANN_PREM_YEARLY),
          youGet: Math.round(AUTO_RENEW_BOOSTER) + Math.round(IB_PAY_WO_AP) + Math.round(LA) + Math.round(MB_G),
          lifeCover: Math.round(DB_G),
        };
  
        return data;
  }

  generatePredefinedOptList(firstId, optionId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i <= 40; i++) {
      list.push({
        id: startOptId,
        label: i,
      });
      startOptId += 1
    }
    return list
  }
  generatePredefinedOptListForFsp(firstId, optionId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i < 40; i++) {
      list.push({
        id: startOptId,
        label: i,
      });
      startOptId += 1
    }
    return list
  }
}
export default new Utils();
